import { FormControl, FormGroup, Validators } from '@angular/forms';

export class TradeCategoryForm extends FormGroup<{
  id: FormControl<number | undefined>;
  categoryName: FormControl<string | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      categoryName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}
